import React, { FC, useEffect, useRef, useState } from "react";
import { useParams, useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { initReactI18next, useTranslation } from "react-i18next";
import moment from "moment";
import Recaptcha from "../../modules/Recaptcha/Recaptchav2";

// import {
//   GoogleReCaptchaProvider,
//   useGoogleReCaptcha,
// } from "react-google-recaptcha-v3";

const SignIn = ({ dispatch_post_authin }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const ref = useRef();
  const [t, i18n] = useTranslation();

  useEffect(() => {}, []);

  // alert(i18n.language);
  return (
    <>
      <div class="bg-light">
        <header className="py-3 mb-auto bg-brand fixed-top">
          <div className="container d-flex justify-content-between align-items-center">
            <a
              className="text-white"
              href="javascript:history.back();"
              onClick={(e) => {
                e.preventDefault();
                history.goBack();

                window.scroll(0, 0);
              }}
            >
              <i className="fas fa-angle-left fa-fw" />
              {t("戻る")}
            </a>
            <h1 className="haederbar-title text-white">{t("プライバシーポリシー")}</h1>
            <a
              href="index.html"
              onClick={(e) => {
                e.preventDefault();
                history.goBack();
                window.scroll(0, 0);
              }}
            >
              <img src="images/brand-white.svg" height={28} alt="SC WORLD EXCHANGE" />
            </a>
          </div>
        </header>
        {(i18n.language === "ja" ? <MainJapanese /> : <></>)}
        {(i18n.language === "en" ? <MainJapanese /> : <></>)}
      </div>
    </>
  );
};

const MainJapanese = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const ref = useRef();
  const [t, i18n] = useTranslation();

  useEffect(() => {}, []);

  return (
    <>
      <main role="main" className="main header-fixed">
        <div className="container">
          <section className="section create-section mx-auto">
            <h2>SC World Exchange Terms of Service</h2>
            <p>
              SC World Exchange is a website belonging to MTA Intec Pte. Ltd.
              Hereinafter, the SC World Exchange website is abbreviated as SC
              World Exchange or this website. The following terms and conditions
              apply to customers of this website. Before you can create an
              account or use any service through our website, you must read and
              understand these Terms of Service to ensure that you fully agree
              to them. If you do not agree to these Terms of Service or any
              subsequent modifications, changes or updates, you may not use any
              of the Services. SC World Exchange reserves the right to change or
              amend any of the terms and conditions contained therein at any
              time. It includes, but is not limited to, any policies or rules on
              this website. We will publish the revised terms on this website
              with the date of the last revision listed at the top of this
              section, or send it via email to the registered email address
              provided by the user. You decide for yourself in any other way
              defined by SC World Exchange. We want you to always look back at
              these Terms and make sure that your copy and understanding of
              these Terms of Service is up-to-date and accurate. If applicable
              law is prohibited, any use of this website and any service will be
              invalid. Preface SC World Exchange provides an online service
              (“platform”) that allows you to exchange different block link
              codes between users. These codes are usually data that displays
              the corresponding blockchain network (commonly known as "tokens")
              transactions, visits and other participation privileges. SC World
              Exchange can provide other auxiliary services to users. To
              facilitate the exchange of tokens. For example, lending, limit
              ordering, order cancellation.
            </p>
            <p>
              1. User qualification When you access or use this website, you
              state that you are at least 18 years old and that your
              transactions have never been suspended or removed from this
              website. And you have to guarantee it. You should also ensure that
              you are not on any trade or economic sanctions list, eg, not
              subject to the restrictions of the UN Security Council sanctions
              list, Singapore's local law, or the application of any trading
              platform is prohibited. Is not ... In addition, SC World Exchange
              may not offer this service in all countries or regions. Moreover,
              it may or may not offer some of this service to users in
              restricted areas, including Cuba, Iran, North Korea, Syria, Sudan,
              Bangladesh, Bolivia, etc. Includes Ecuador, Kyrgyzstan, China, the
              United States, etc. The list of restricted areas is subject to
              change at any time. If your area becomes restricted, SC World
              Exchange will notify you by email or in any other way we need to
              notify users who access your country. The content of this
              consultation is not subject to resistance from the country to
              which the user belongs or local law. Therefore, if you do not meet
              these requirements, please do not use our service. Finally, you
              must state and guarantee that you will not use this website for
              any illegal event, such as illegal gambling, money laundering,
              fraud, extortion, extortion, data breaches and terrorism and other
              Includes, but is not limited to, financial assistance for acts of
              violence. Despite the above provisions, depending on the location
              of the user, SC World Exchange may, in whole or in part, in all or
              in part, in all markets, whether at its own discretion or as
              required by law or statute. It may not provide the services of the
              department.
            </p>
            <p>
              2. Account; Transfer of assets of a third party You must always
              use the SC World Exchange (“Account”) to create an account in
              order to access and use the services. .. You should agree that:
              (a) Provide accurate, newest and complete information when
              creating an account. (B) Maintain and timely update your account
              information to keep it accurate, complete and up-to-date. (C) Keep
              your login credentials secure and confidential, and restrict
              access to your account and your computer, tablet or mobile device.
              (D) If you discover any security loopholes related to this website
              or your account, notify SC World Exchange in a timely manner. (E)
              Responsible for all activities that occur under your account and
              accept all unlicensed risks on it. You must provide a valid email
              address for SC World Exchange to create an account. You agree to
              our renewal as keeping your email address. To understand that SC
              World Exchange may suspend or discontinue your ability to use the
              Services, you may receive an email by sending a notice to SC World
              Exchange. You can revoke your consent. You may find that SC World
              Exchange sends emails, but the email address is incorrect, has
              expired, or my service provider blocks my email or is blocked by a
              junk email filter. You understand and agree that SC World Exchange
              will be deemed to have already provided communication if you do
              not receive or receive electronic communication. If you choose to
              transfer the token from your account to a third party wallet or
              other address, the administrator of the new address may refuse the
              transfer, or due to platform technology or other related issues. ,
              May cause transfer failure. You agree that SC World Exchange will
              not be held liable for any loss incurred due to a transfer
              failure. SC World Exchange reserves the right to limit the number
              of open or retained accounts for you or your affiliates.
            </p>
            <p>
              3. Privacy policy Privacy is very important to us. We either
              include in our Privacy Policy, or require law enforcement
              agencies, courts, or SC World Exchange to provide identification
              or statutory proof by compliance requirement requirements. We will
              only disclose information to third parties who may need to meet
              their reporting requirements.
            </p>
            <p>
              4. Confidentiality of information transmission on the Internet
              Shipping data and information (including communications via email)
              over the Internet and other publicly accessible networks is not
              always secure and may be lost or lost during the shipping process.
              It may be blocked or changed. Therefore, SC World Exchange is not
              responsible for any loss or damage you may encounter and invites
              you for any transmission via the Internet or other publicly
              accessible networks. We are not responsible for any costs and this
              includes, but is not limited to, platform-related emails, or
              CoinBene, emails containing personal information. SC World
              Exchange will make commercially reasonable efforts to protect the
              privacy of the information you provide to SC World Exchange, and
              in addition to that information in accordance with SC World
              Exchange's Privacy Policy, against such information. The
              information we process and provide to SC World Exchange should not
              be considered confidential under any circumstances. SC World
              without any liability to SC World Exchange, even if this
              information is promulgated by SC World Exchange or accessed by a
              third party without the consent of SC World Exchange. It does not
              take any responsibility for Exchange.
            </p>
            <p>
              5. Risk Disclosure Statement SC World Exchange provides
              enforcement services and does not advise on the revenue of any
              particular transaction or its tax consequences. In general, before
              using our service, users should understand the following: Trading
              tokens are very dangerous. Each specific token has a unique
              feature set that more or less fluctuates its value. Factors that
              go beyond SC World Exchange regulations can also affect the market
              liquidity of certain tokens, such as regulatory activity, market
              manipulation and price fluctuations. Blockchain networks can go
              offline due to program errors, failures and many other unforeseen
              reasons. SC World Exchange does not risk any loss due to factors
              that make it impossible to control the feasibility of trading or a
              particular blockchain network. In general, it is recommended that
              users have limited trading experience and tolerance for low risk
              and do not actively trade. Based on speculation that the value of
              tokens is at high risk, users should not trade losses beyond their
              tolerance. Expert technical knowledge is required to know the
              token. Tokens are usually written in a very specialized language
              and require a full understanding of application cryptography and
              computer science in order to understand the inherent risks. Any
              token traded on SC World Exchange does not indicate that SC World
              Exchange permits or denies the technology used, and you understand
              the risks to the specifics of each token. Can't be used in place
              of. In accordance with this clause, we do not guarantee that any
              tokens we trade will pass and we will not be held responsible for
              it. You accept the risk of trading tokens. When making any
              transaction on the Platform, you should show that you are already
              fully responsible for independently assessing and investigating
              the potential risks of transactions and tokens. You make full use
              of your knowledge, market experience, professional advice and
              other experience to assess the potential benefits and risks of
              trading and tokens. You are responsible for complying with
              applicable law. You agree that SC World Exchange is not
              responsible for determining what laws apply to your transactions,
              including tax law. You are fully responsible for any tax filing
              and payment resulting from your use of the Services. Recognize and
              accept operational risks. Recognize the operational challenges and
              accept them. SC World Exchange can face state-of-the-art network
              attacks, operations and technical challenges that can lead to
              unexpected spikes in usage and disruption of other services. You
              should understand that operational issues can delay the service of
              the platform. You include technical difficulties resulting from
              state-of-the-art attacks that you should agree to accept the risk
              of the invited transaction failing due to difficult technical
              issues. You agree not to squeeze SC World Exchange's liability for
              any associated loss. SC World Exchange does not provide advice on
              trading risk. SC World Exchange does not advise on transaction
              risk. If SC World Exchange or its consultants, under any
              circumstances, provide trading advice, market comments or any
              other information, it is all an additional part of your
              relationship with us and SC World Exchange. Or it does not
              represent any investigation or due diligence of truth by the
              consultant. SC World Exchange is a regulated entity and must
              comply with applicable law. Applicable laws, statutes and
              administrative orders may require SC World Exchange to freeze
              withdrawals and / or transactions at the request of government
              agencies, or to provide information about your account. In
              addition, our record keeping and customer certification programs
              are subject to change at any time in accordance with law or
              industry practice. You must accept any inconvenience or other
              consequences that may result to you due to the laws we must comply
              with. The user accepts all results of sending the token to our
              platform address. Token trading may be irreversible. Once you have
              shipped the token to an address, you may be at risk of losing the
              token. For example, the wrong address may be entered and the
              entity owner at this address may not be able to contact it
              forever, or the entity owner at the address may not be able to
              return the token, or the entity owner at the address may return
              the token. Before we do, we first need to complete some missions,
              such as identity verification.
            </p>
            <p>
              6. User rights You agreed: All rights to the services and related
              software, websites and technologies, including ownership and
              interests, and all intellectual property rights within them,
              belong to SC World Exchange; No rights or interests in the service
              are assigned except for the limited licenses granted by this
              license; This service is protected by copyright and other
              intellectual property laws. SC World Exchange reserves all rights
              not expressly recognized by this clause. This website provides
              assets and accounts that users have in their accounts in
              accordance with these requirements, including but not limited to
              public security agencies, prosecutors' agencies, courts, customs,
              tax authorities and other judicial agencies, government agencies
              and military agencies. On the other hand, you have the right to
              inquire, freeze, and deduct. Users are entitled to the incentives
              granted by SC World Exchange after their contributions, such as by
              publishing information in accordance with the relevant provisions
              of the website. You have the right to modify the modifiable
              information in your personal account, choosing your own nickname,
              entering introductory text, and deciding whether to provide
              non-essential content. I can do it. Users have the right to
              participate in various online and offline activities offered by SC
              World Exchange. Users have the right to enjoy various other
              services provided by SC World Exchange in accordance with the
              rules of the SC World Exchange website. If your revision of the
              Terms of Service makes sense or you are dissatisfied with the
              services of SC World Exchange, you can exercise the following
              rights: Stop using SC World Exchange network services; Notify SC
              World Exchange to stop service through channels such as customer
              service. After the service ends, the user immediately ceases the
              right to use the SC World Exchange network service. In this case,
              SC World Exchange is not obligated to transmit any raw information
              or incomplete services to you or any third party with whom you
              have no direct relationship.
            </p>
            <p>
              7. User behavior and obligations Users should not do the following
              when using the following services: (1) Cooperate or violate any
              one of them by using the law, decree, ordinance, regulation system
              or any of these services to violate the required membership system
              of autonomous organizations or similar organizations. thing. (2)
              You must not use this site to compromise national security,
              divulge state secrets, or violate the legitimate rights and
              interests of national social groups and citizens. (3) To provide
              false, inaccurate, incomplete or misleading information. (4)
              Infringe the copyright, patent right, trademark or intellectual
              property right of SC World Exchange or a third party. (5)
              Distribute advertisements, promotional materials, any junk maces,
              junk emails, or chain letters that are not permitted or licensed.
              (6) Accessing our services or extracting data using web crawler
              tools or similar technologies; (7) Any direction of a disassembled
              or disassembled website or service shall seek access to any source
              code, basic ideas or concepts, and algorithms. (8) Take any
              action, impose an unreasonable or unbalanced burden on our
              infrastructure, or harm, block, or expropriate any system, data,
              or information. thing; (9) Sending or uploading materials
              containing viruses, Trojan horses, worms and any other harmful or
              harmful programs to the website. (10) Access this website, other
              SC World Exchange accounts, or connect to this website's computer
              system or network without a license, through a password, by trying
              to mine or by any other method. (11) Transfer any rights or
              obligations permitted by these provisions.
            </p>
            <p>
              8. Do not transfer While the accounts and services provided to
              users are not transferable under any circumstances and can only be
              used by users, SC World Exchange transfers or distributes all
              rights, interests and obligations to anyone. , Has the right to
              sell. The terms remain valid for any lender, heir and assignee to
              SC World Exchange.
            </p>
            <p>
              9. Stop the service permanently If SC World Exchange suspects that
              you or someone else is using your account to engage in illegal
              activities, SC World Exchange will (a) suspend or suspend access
              to the Services. And (b) suspend or cancel your account at the
              request of a valid warrant or court order. If your account does
              not comply with (i) relevant laws (ii) valid warrants or court
              orders and you are prohibited from making a transfer, you may
              transfer tokens associated with your account within 90 days of
              discontinuing service. I will. If any transaction is on hold when
              your account is canceled or suspended, that transaction may be
              canceled or returned. SC World Exchange On the other hand, you may
              not be able to cancel your account if you think that the act of
              canceling your account is to avoid investigation or any payment to
              SC World Exchange. After canceling your account, you license SC
              World Exchange to cancel or suspend your transfer hold. It then
              returns the wallet address you provided to SC World Exchange with
              tokens related to these transactions after providing an electronic
              public notice system to notify you. If you or SC World Exchange
              discontinues access to these Terms or the Services and suspends or
              cancels your account, you are responsible for all payments. .. If
              a technical issue causes a system interruption or account error,
              SC World Exchange may suspend access to your account until the
              issue is resolved.
            </p>
            <p>
              10. Token ownership You here give us any tokens related to the
              Platform that you own, or that you have a valid license to trade
              using these Tokons and are triggered by your account. All
              transactions you make are for your own account and you must prove
              that you are not representing any other person or entity.
            </p>
            <p>
              11. Compensation You are responsible for SC World Exchange and its
              affiliates and service providers, as well as their respective
              officers, directors and agents, except that any breach of this
              section by SC World Exchange alone may result in loss due to third
              party claims. , Joint ventures, employees and representatives
              should be reimbursed for the loss and should be exempted from
              liability. Similarly, SC World Exchange also allows you and your
              affiliates, service providers, and their respective officers,
              directors, and deputies, except that your sole breach of this
              clause would result in loss due to third party claims. Encourage
              people, limited partnerships, employees and representatives to
              reimburse their losses and exempt them from liability.
            </p>
            <p>
              12. Disclaimer (1) SC World Exchange does not guarantee that the
              service will not be interrupted, nor does it guarantee the
              timeliness or safety of the service, and will take responsibility
              unless it is the fault of one of the networks on the SC World
              Exchange side. I will not bear it. (2) SC World Exchange does not
              guarantee that the information and services on the website
              platform will fully meet the needs of users. SC World Exchange
              shall not be liable for any errors, insults, slander, omissions,
              obscenity, pornography or blasphemy cases that you may encounter
              during the process of accepting the SC World Exchange Services.
              (3) SC World Exchange is not responsible for saving, modifying,
              deleting or failing to save user-submitted information. Since
              CoinBene is not intentional, we are not responsible for any layout
              errors or carelessness caused. (4) SC World Exchange reserves the
              right to delete information within SC World Exchange that falls
              under the provisions of various laws or regulations, and reserves
              the right not to notify the user. (5) User comments published by
              all users within the SC World Exchange represent only the user's
              personal opinion and indicate that this website agrees with or
              supports its depiction. This website does not assume any legal
              liability caused by user comments. (6) All notifications sent to
              users will be served by SC World Exchange through the official
              page of regular email. SC World Exchange is not liable for any
              activity or information obtained, such as benefits, through
              CoinBene's non-authorized channels. (7) SC World Exchange reserves
              the right to adjust commission rates for deposits and withdrawals,
              transactions, etc. according to market conditions and to decide
              the end of the free promotion period. (8) SC World Exchange is not
              responsible for brokers, matchmakers, agents or consultants for
              any transaction you use the Services. And SC World Exchange is not
              responsible for receiving orders.
            </p>
            <p>
              13. Arbitration Please read this part carefully-it can have a
              significant impact on your legal rights and may include you the
              right to submit legal documents in court and provide you with a
              jury. there is. You agree to arbitrate with SC World Exchange the
              Services or any disputes arising in connection with the Services,
              and unless arbitration is not required, one of them may be the
              copyright, trademark, trade name, logo. Includes suspicion of
              illegal use for compensation or compensation for trade secret or
              patent disputes. Arbitration takes precedence over court
              prosecution or jury trials. You agree with SC World Exchange that
              you will notify the other party within 30 days of any dispute and
              will attempt to resolve the dispute before filing any arbitration
              claim with it. Any arbitration will take place in Singapore and
              the arbitration will be secretly decided by a single arbitrator.
              You and the SC World Exchange agree that the courts of Singapore
              have exclusive jurisdiction over any proceedings of arbitration
              between the parties and any proceedings of arbitration between the
              parties not subject to arbitration. In any arbitration, the
              parties must not examine each other, and the arbitrator does not
              allow both parties to examine each other; instead, on the date and
              time when both parties agreed with each other prior to the final
              hearing. We shall show evidence in support of our position. The
              arbitrator reserves the right to grant reversal measures granted
              in the event of a court indictment, except for the procedures and
              reversal measures considered below. Neither you nor we will
              participate in a class action or class action arbitration of any
              claim relating to this clause. If SC World Exchange is one of the
              parties to the proceedings, you also agree not to participate in
              claims filed by a private attorney or agent or joint claims
              involving others. If the above class action proceedings and other
              claims against a third party are found to be unenforceable, the
              prohibition is deemed to have already been removed from this
              section and the other provisions related to arbitration remain
              valid. ..
            </p>
            <p>
              14. Manage languages ​​and translations You agree to these terms
              and the SC World Exchange Privacy Policy and other notices
              promulgated through the Services have already been proposed in
              English. Translations of any of the above files in other languages
              ​​are available, but these translations may not be up-to-date or
              complete. Therefore, you agree that if there is any resistance
              between the English version of the above file and any other
              translation, the English version of that file will apply.
            </p>
            <p>
              15. Customer service If you have any feedback, complaints or
              issues, please contact customer service through
              infot@sc-worldexchange.com. When contacting us, please provide
              your name and email address, as well as any other information you
              may need to identify you, and any transaction information related
              to your feedback or complaint.
            </p>
          </section>
        </div>
      </main>
    </>
  );
};

export default SignIn;
